<template>
	<div
		class="bg-purple-900 bg-gradient-to-b from-gray-900 via-gray-900 to-purple-800 leading-5 h-full w-full flex justify-center overflow-hidden min-h-screen">
		<div
			class="flex-col flex self-center md:px-14 sm:max-w-4xl md:max-w-md z-10">
			<div class="self-start hidden lg:flex flex-col text-gray-300">
				<h1 class="my-3 font-semibold text-4xl">Welcome back</h1>
				<p class="pr-3 text-sm opacity-75">
					Here is Pass2Peer, your one stop for sharing materials to peers and
					help them out.
					<br />
					Login now!
				</p>
			</div>
		</div>
		<div class="flex justify-center self-center h-full w-11/12 md:w-auto z-10">
			<div class="py-12 px-8 md:px-12 bg-white mx-auto rounded-3xl w-96">
				<div class="mb-7">
					<h3 class="font-semibold text-2xl text-gray-800">Sign In</h3>
					<p class="text-gray-400">
						Don't have an account?
						<router-link
							to="/signup"
							class="text-sm text-purple-700 hover:text-purple-700">
							Sign Up
						</router-link>
					</p>
				</div>
				<form
					class="space-y-6"
					@submit.prevent="handleSubmit()">
					<div class="">
						<input
							v-model="email"
							class="w-full text-sm px-4 py-3 bg-gray-200 focus:bg-gray-100 border border-gray-200 rounded-lg focus:outline-none focus:border-purple-400"
							type="email"
							autocomplete="on"
							placeholder="Email" />
					</div>
					<div
						class="relative"
						x-data="{ show: true }">
						<input
							v-model="password"
							autocomplete="on"
							placeholder="Password"
							:type="!show ? 'password' : 'text'"
							class="text-sm text-black px-4 py-3 rounded-lg w-full bg-gray-200 focus:bg-gray-100 border border-gray-200 focus:outline-none focus:border-purple-400" />
						<div
							class="flex items-center absolute inset-y-0 right-0 mr-3 text-sm leading-5">
							<svg
								@click="show = !show"
								:class="{ block: !show, hidden: show }"
								class="h-6 text-purple-700"
								xmlns="http://www.w3.org/2000/svg"
								viewBox="0 0 612 612"
								style="enable-background: new 0 0 612 612"
								xml:space="preserve">
								<g>
									<g>
										<path
											fill="currentColor"
											d="M609.608,315.426c3.19-5.874,3.19-12.979,0-18.853c-58.464-107.643-172.5-180.72-303.607-180.72
												S60.857,188.931,2.393,296.573c-3.19,5.874-3.19,12.979,0,18.853C60.858,423.069,174.892,496.147,306,496.147
												S551.143,423.069,609.608,315.426z M306,451.855c-80.554,0-145.855-65.302-145.855-145.855S225.446,160.144,306,160.144
												S451.856,225.446,451.856,306S386.554,451.855,306,451.855z" />
										<path
											fill="currentColor"
											d="M306,231.67c-6.136,0-12.095,0.749-17.798,2.15c5.841,6.76,9.383,15.563,9.383,25.198c0,21.3-17.267,38.568-38.568,38.568
												c-9.635,0-18.438-3.541-25.198-9.383c-1.401,5.703-2.15,11.662-2.15,17.798c0,41.052,33.279,74.33,74.33,74.33
												s74.33-33.279,74.33-74.33S347.052,231.67,306,231.67z" />
									</g>
								</g>
							</svg>
							<svg
								@click="show = !show"
								:class="{ block: show, hidden: !show }"
								class="h-6 text-purple-700"
								viewBox="0 0 24 24"
								xmlns="http://www.w3.org/2000/svg">
								<g data-name="Layer 2">
									<g data-name="eye-off">
										<rect
											width="24"
											height="24"
											opacity="0" />
										<circle
											cx="12"
											cy="12"
											r="1.5" />
										<path
											fill="currentColor"
											d="M15.29 18.12L14 16.78l-.07-.07-1.27-1.27a4.07 4.07 0 0 1-.61.06A3.5 3.5 0 0 1 8.5 12a4.07 4.07 0 0 1 .06-.61l-2-2L5 7.87a15.89 15.89 0 0 0-2.87 3.63 1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25a9.48 9.48 0 0 0 3.23-.67z" />
										<path
											fill="currentColor"
											d="M8.59 5.76l2.8 2.8A4.07 4.07 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5 4.07 4.07 0 0 1-.06.61l2.68 2.68.84.84a15.89 15.89 0 0 0 2.91-3.63 1 1 0 0 0 0-1c-.64-1.11-4.16-6.68-10.14-6.5a9.48 9.48 0 0 0-3.23.67z" />
										<path
											fill="currentColor"
											d="M20.71 19.29L19.41 18l-2-2-9.52-9.53L6.42 5 4.71 3.29a1 1 0 0 0-1.42 1.42L5.53 7l1.75 1.7 7.31 7.3.07.07L16 17.41l.59.59 2.7 2.71a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z" />
									</g>
								</g>
							</svg>
						</div>
					</div>
					<div class="flex items-center justify-between">
						<div class="text-sm ml-auto">
							<a
								href="#"
								class="text-purple-700 hover:text-purple-600">
								Forgot your password?
							</a>
						</div>
					</div>
					<div>
						<button
							type="submit"
							class="w-full flex justify-center bg-purple-800 hover:bg-purple-700 text-gray-100 p-3 rounded-lg tracking-wide font-semibold cursor-pointer transition ease-in duration-500">
							Sign in
						</button>
					</div>
				</form>
				<div class="mt-7 text-center text-gray-500 text-xs">
					<span>Copyright © 2022</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { store } from '@/components/store'

export default {
	name: 'Login',
	data() {
		return {
			show: false,
			email: '',
			password: ''
		}
	},
	methods: {
		async handleSubmit() {
			const data = {
				email: this.email,
				password: this.password
			}
			const res = await axios.post('auth/login', data)
			if (res.status === 200) {
				Vue.$toast.success('Logged in successfully', { position: 'top' })
				localStorage.setItem('token', res.data.jwt)
				store.loggedIn = true
				this.$router.push('/')
			} else alert(res.data.message)
		}
	}
}
</script>
